import React, { useState } from 'react';
import { getCountryCode, getDataFromLocalStorage } from 'utils/helpers';
import ChatContainer from './ChatContainer';
import './ChatContainer.scss';

const ChatTab = ({ paperData }) => {
  const { id, authorName, user_country_code, user_mobile_no, user_id } =
    paperData;
  const whatsappNumber = `${String(user_country_code)}${String(
    user_mobile_no
  )}`;

  return (
    <div>
      <ChatContainer  
        name={authorName}
        paperId={id}
        whatsapp_number={whatsappNumber}
        user_id={user_id}
      />
    </div>
  );
};

export default ChatTab;
